import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import Button from '../Button';
import * as Style from './style';

const Table = ({
    title,
	tableData,
	target,
	forceLoaded,
}) => {
    const [tData, setTdata] = useState(null);
	const [loading, setLoading] = useState(true);
	const [hasData, setHasData] = useState(false);
	const history = useHistory();

    useEffect(() => {
		setTdata(tableData);
		setHasData(tableData.length > 0);
	}, [tableData]);

    useEffect(() => {
		if (tData != null || forceLoaded) setLoading(false);
	}, [tableData]);

	const targets = {
		report: data => history.push(`./relatorios/${data.id}`, { campaign: data }),
		campaign: data => history.push(`./minhascampanhas/${data.id}`),
	};

    const tableRow = data => (
	<tr key={data.id}>
		<td><em>{ data.status }</em></td>
		<td><em>{ data.id }</em></td>
		<td><em>{ data.date }</em></td>
		<td><em>R${ data.value }/mês</em></td>
		<td style={{ textTransform: 'capitalize' }}><em>{ data.channel }</em></td>
		<td>
			<Button
				fit
				fontSize="12px"
				lineheight="20px"
				padding="0"
				uppercase={false}
				fontWeight="500"
				type="button"
				backgroundcolor="transparent"
				textColor="#F3123C"
				hoverColor="0.8"
				onClick={() => targets[target](data)}
			>
				Ver relatório
			</Button>
		</td>
	</tr>
    );

    const emptyData = () => (
	<tr>
		<td colSpan="6">
			<em className="empty-data">Não há dados</em>
		</td>
	</tr>
    );

    const dataRender = () => (tData.length !== 0
        ? tData.map(data => tableRow(data))
        : emptyData());

    const dataLoading = () => (loading
        ? (
	<tr>
		<td colSpan="6">
			<em className="empty-data">Carregando... Aguarde</em>
		</td>
	</tr>
        ) : dataRender());

    return (
	<>
		{ hasData
		? (
			<Style.TableBox>
				<div>
					{title && (
					<div>
						<Style.Title>{title}</Style.Title>
					</div>
				)}
				</div>
				<div>
					<div>
						<Style.Table>
							<thead>
								<tr>
									<th><em>status</em></th>
									<th><em>id campanha</em></th>
									<th><em>contratada em</em></th>
									<th><em>valor</em></th>
									<th><em>campanha</em></th>
									<th><em>relatórios</em></th>
								</tr>
							</thead>
							<tbody>
								{ dataLoading() }
							</tbody>
						</Style.Table>
					</div>
				</div>
			</Style.TableBox>
		) : (<></>)}
	</>
    );
};

Table.defaultProps = {
    tableData: [],
};

PropTypes.Table = {
    title: PropTypes.string,
	tableData: PropTypes.array.isRequired, 
	target: PropTypes.string.isRequired,
	forceLoaded: PropTypes.bool,
};

export default Table;
